import cn from "classnames";
import React, { useContext } from "react";
import ScrollerContext from "../context";
import css from "./index.module.scss";

export type ScrollerItemProps = {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
};

const ScrollerItem = ({
  className,
  children,
}: ScrollerItemProps) => {
  const { fullWidthItemsFinal, fullPageStretch, sideHeader } = useContext(ScrollerContext);

  return (
    <li
      className={cn(css["hbd-scroller__item"], {
        [css["hbd-scroller__item--full-width"]]: fullWidthItemsFinal,
        [css["hbd-scroller__item--full-page-stretch"]]: fullPageStretch,
        [css["hbd-scroller__item--side_header"]]: fullPageStretch && sideHeader,
      }, className)}
    >
      {children}
    </li>
  );
};

export default ScrollerItem;
